const TRADITIONAL_CHINESE_STATIC_TEXT: Record<string, string> = {
  关闭: '關閉',
  上一个: '上一個',
  下一个: '下一個',
  退出: '退出',
  '全屏媒体查看器。按 Escape 可关闭，使用左右方向键进行切换。':
    '全螢幕媒體檢視器。按 Escape 關閉。使用左右方向鍵導覽。',
  正在加载完整图片: '正在載入完整圖片',
  '加载中...': '載入中...',
  '正在加载 3D 查看器...': '正在載入 3D 檢視器...',
  未提供资源地址: '未提供資源位址',
  '无法加载 3D 查看器库': '無法載入 3D 檢視器程式庫',
  '无法加载 3D 模型': '無法載入 3D 模型',
  无法加载视频: '無法載入影片',
  视频加载已中止: '影片載入已中止',
  加载视频时发生网络错误: '載入影片時發生網路錯誤',
  视频解码错误: '影片解碼錯誤',
  不支持的视频格式: '不支援的影片格式',
  没有可用的视频源: '沒有可用的影片來源',
  '正在加载视频...': '正在載入影片...',
  视频素材: '影片素材',
  'URL 无法访问': 'URL 無法存取',
  'URL 可访问': 'URL 可存取',
  是: '是',
  否: '否',
  来源: '來源',
  侧边栏: '側邊欄',
  '显示移动端侧边栏。': '顯示行動版側邊欄。',
  切换侧边栏: '切換側邊欄',
  更多页面: '更多頁面',
  转到上一页: '前往上一頁',
  转到下一页: '前往下一頁',
  页面未找到: '找不到頁面',
  '你要查找的页面不存在，或已被移动。': '您要找的頁面不存在或已移動。',
  无权访问: '無權存取',
  '你没有权限查看此页面。如果你认为这是错误，请向工作区管理员申请访问权限。':
    '您沒有權限檢視此頁面。若您認為這是錯誤，請向工作區管理員申請存取權。',
  返回: '返回',
  返回首页: '返回首頁',
  前往仪表盘: '前往儀表板',
  错误: '錯誤',
  出现了一些问题: '發生錯誤',
  '发生了意外错误。': '發生未預期的錯誤。',
  重试: '重試',
  '请重试。如果问题持续出现，请联系支持团队。':
    '請重試。若問題持續發生，請聯絡支援團隊。',
  参考: '參考',
  建议: '建議',
};

export function createTraditionalChineseStaticCopy<T>(value: T): T {
  if (typeof value === 'string')
    return (TRADITIONAL_CHINESE_STATIC_TEXT[value] ?? value) as T;
  if (Array.isArray(value))
    return value.map(createTraditionalChineseStaticCopy) as T;
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nested]) => [
        key,
        createTraditionalChineseStaticCopy(nested),
      ])
    ) as T;
  }
  return value;
}
